import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: secondaryFont;
    src: url(${({ theme }) => theme.secondaryFont.url});
  };

  // Headings font family
  @font-face {
    font-family: ${({ theme }) => theme.headersFont.name};
    src: url(${({ theme }) => theme.headersFont.url});
  };

  // Default font family
  @font-face {
    font-family: ${({ theme }) => theme.font.name};
    src: url(${({ theme }) => theme.font.url});
  };

  html {
    height: 100%;
  }

  body {
    min-height: 100%; 
    height: 100%;
    margin: 0;
    padding: 0;
    background: #fff;

    ${({ theme }) => `
      color: ${theme.textColour};
      font-family: ${theme.font.name};
      font-size: ${theme.fontSize}px;
    `}
  }

  /* Solution for lock scroll on Safari */
  body [class*="is-lock-body-scroll"] {
      overflow: hidden;
  }

  body [class*="scroll-lock-extended"] {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }


  button {
    padding: 0;
    border: none;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
    outline: none;
  }
  
  button {
    margin: 0;
  }

  textarea {
    font-family: inherit;
    outline: none;
  }

  input {
    padding: 0;
    margin: 0; // safari has margins for inputs by defaults
    border: none;
    font: inherit;
    outline: none;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  fieldset {
    margin: 0;
    padding: 0;
    border: none;
  }

  a {
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }

    ${({ theme }) => `
      color: ${theme.primaryColour}; //TODO figure out why in theme exist variable linkColour but uses primaryColour instead 
    `}
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }
`;

export default GlobalStyle;
